import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'

export default {
  state: {
    courses: {},
  },

  actions: {
    getStudentCourse ({ commit }) {
      return api.getStudentCourse().then(storeAllEntities(commit))
    },
  },

  getters: {},
}
